// Хелперы количества товара для заказа (Item#min_order_count,
// Item#default_order_count, Item#warehouse_count). Повторяют логику мобильного
// приложения: client_app/src/hooks/useProductQuantityAdjustment.ts и
// client_app/src/shared/Widgets/ProductQuantity.tsx (CatalogQuantitySelector).
//
// Значения приходят из двух мест и приводятся к camelCase ниже:
//  - виджеты каталога/баннера — из data-params (WebsiteItem#web_to_cart_hash):
//    minOrderCount / defaultOrderCount / warehouseCount;
//  - строки корзины — из вложенной модели товара item.model (ItemV3Serializer):
//    min_order_count / default_order_count / warehouse_count.

function num(source, camelKey, snakeKey) {
  if (!source) return undefined;
  const v = source[camelKey] != null ? source[camelKey] : source[snakeKey];
  const n = parseInt(v, 10);
  return Number.isNaN(n) ? undefined : n;
}

// Минимально допустимое количество для заказа, не меньше 1 (мобилка: `min_order_count || 1`).
export function minOrderCount(source) {
  const n = num(source, 'minOrderCount', 'min_order_count');
  return n > 1 ? n : 1;
}

// Потолок количества по складу. Как в мобилке (`warehouse_count || MAX`): склад 0
// (нет жёсткого остатка) трактуется как «без ограничения сверху». У набора с
// условием «не больше N в заказе» (#315) потолок ещё и N.
export function maxOrderCount(source) {
  const n = num(source, 'warehouseCount', 'warehouse_count');
  const stock = n > 0 ? n : Infinity;
  const b = num(source, 'bundleMaxPerOrder', 'bundle_max_per_order');
  return b > 0 ? Math.min(stock, b) : stock;
}

// Набор «только для первого заказа», а покупатель уже заказывал (#315): в корзину
// не кладётся, лежащий в ней — не прибавить. Решает сервер: data-params карточки
// (bundleFirstOrderUsed) или строка корзины v3 (bundle_first_order_used).
export const FIRST_ORDER_USED_NOTE = 'Набор - только для первого заказа, а у вас заказ уже был';
export function isFirstOrderUsed(source) {
  return !!(source && (source.bundleFirstOrderUsed || source.bundle_first_order_used));
}

// Стартовое количество при первом добавлении: количество по умолчанию, но не ниже
// минимального (мобилка: `Math.max(default_order_count || 0, min_order_count || 1)`).
export function initialOrderCount(source) {
  const min = minOrderCount(source);
  const def = num(source, 'defaultOrderCount', 'default_order_count') || 0;
  return Math.min(Math.max(def, min), maxOrderCount(source));
}

// Признак отсутствия на складе (мобилка: `warehouse_count === 0` → «нет в наличии»).
export function isOutOfStock(source) {
  return num(source, 'warehouseCount', 'warehouse_count') === 0;
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/orderCount.js